import { cn } from "@/lib/utils";

interface MemberAvatarProps {
  name: string | null;
  imageUrl: string | null;
  className?: string;
}

function initials(name: string | null): string {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

export function MemberAvatar({ name, imageUrl, className }: MemberAvatarProps) {
  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={name ?? "Member avatar"}
        width={32}
        height={32}
        className={cn("h-8 w-8 rounded-full object-cover", className)}
      />
    );
  }
  return (
    <div
      className={cn(
        "flex h-8 w-8 items-center justify-center rounded-full bg-slate-200 text-xs font-medium text-slate-600",
        className
      )}
      aria-label={name ?? "Member avatar"}
    >
      {initials(name)}
    </div>
  );
}
